import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const BookmarkFilled = createSvgIcon(<path d="M3 0V24L12 17.993L21 24V0H3Z" />, 'BookmarkFilled')

export default BookmarkFilled
